import { axios } from '../../../axios';

const getHomeTourRequests = () => {
    return axios.get('/properties/requestTour')
}

const createHomeTourRequests = (data) => {
    return axios.post('/properties/requestTour', data)
}

const acceptOrRejectRequest = (id, data) => {
    return axios.put(`/properties/requestTour/${id}`, data)
}

export { getHomeTourRequests, createHomeTourRequests, acceptOrRejectRequest }